<div class="template-panel">
  <p class="template-intro">
    In order to start your service please contact your project and set a date for the first meeting. Contact the project at the e-mail address you find on the Assigned Services page, or by accessing that association's service.
  </p>
  <p class="template-intro">
    Send the contact an e-mail using <strong>the suggested template</strong> below:
  </p>

  <button type="button" class="template-toggle" (click)="opened = !opened">
    First meeting contact e-mail template
    <i class="fa" [ngClass]="opened ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
  </button>

  <div *ngIf="opened" class="template-body">
    <p><strong>Subject: HSBooster.eu – First meeting with Expert</strong></p>
    <p>Dear [Project Applicant Name],</p>
    <p>I am the Expert assigned from HSbooster.eu to assist you in the standardisation activities of your project [project name].</p>
    <p>I would like to schedule a call with you to start this service. Here are some options that you can choose from:</p>
    <ul>
      <li>Insert option 1</li>
      <li>Insert option 2</li>
      <li>Insert option 3</li>
    </ul>
    <p>This will be an introductory meeting which will help us know each other better and understand your needs. During the meeting we'll discuss:</p>
    <ul>
      <li><strong>Project status</strong> — topic, consortium members, timeline, aim, project maturity, finance, project PI</li>
      <li><strong>Expected results</strong> — your starting point, what you expect to gain through HSbooster services and from me as an expert</li>
    </ul>
    <p>Looking forward to your feedback.</p>
    <p>Best regards,<br>Expert signature</p>
  </div>
</div>
